(() => {
	"use strict";
	var e, t = {
			2278: (e, t, o) => {
				o.r(t);
				var r, n, l, i, s, c, a, u, p = o(6358),
					f = o(7082),
					d = function() {
						return "undefined" != typeof window
					},
					y = function() {
						return r || d() && (r = window.gsap) && r.registerPlugin && r
					},
					g = function(e) {
						return "string" == typeof e
					},
					v = function(e) {
						return "function" == typeof e
					},
					h = function(e, t) {
						var o = "x" === t ? "Width" : "Height",
							r = "scroll" + o,
							n = "client" + o;
						return e === l || e === i || e === s ? Math.max(i[r], s[r]) - (l["inner" + o] || i[n] || s[n]) : e[r] - e["offset" + o]
					},
					m = function(e, t) {
						var o = "scroll" + ("x" === t ? "Left" : "Top");
						return e === l && (null != e.pageXOffset ? o = "page" + t.toUpperCase() + "Offset" : e = null != i[o] ? i : s),
							function() {
								return e[o]
							}
					},
					x = function(e, t) {
						if (!(e = c(e)[0]) || !e.getBoundingClientRect) return {
							x: 0,
							y: 0
						};
						var o = e.getBoundingClientRect(),
							r = !t || t === l || t === s,
							n = r ? {
								top: i.clientTop - (l.pageYOffset || i.scrollTop || s.scrollTop || 0),
								left: i.clientLeft - (l.pageXOffset || i.scrollLeft || s.scrollLeft || 0)
							} : t.getBoundingClientRect(),
							a = {
								x: o.left - n.left,
								y: o.top - n.top
							};
						return !r && t && (a.x += m(t, "x")(), a.y += m(t, "y")()), a
					},
					T = function(e, t, o, r, n) {
						return isNaN(e) || "object" == typeof e ? g(e) && "=" === e.charAt(1) ? parseFloat(e.substr(2)) * ("-" === e.charAt(0) ? -1 : 1) + r - n : "max" === e ? h(t, o) - n : Math.min(h(t, o), x(e, t)[o] - n) : parseFloat(e) - n
					},
					b = function() {
						r = y(), d() && r && "undefined" != typeof document && document.body && (l = window, s = document.body, i = document.documentElement, c = r.utils.toArray, r.config({
							autoKillThreshold: 7
						}), a = r.config(), n = 1)
					},
					k = {
						version: "3.12.5",
						name: "scrollTo",
						rawVars: 1,
						register: function(e) {
							r = e, b()
						},
						init: function(e, t, o, i, s) {
							n || b();
							var c = this,
								a = r.getProperty(e, "scrollSnapType");
							c.isWin = e === l, c.target = e, c.tween = o, t = function(e, t, o, r) {
								if (v(e) && (e = e(t, o, r)), "object" != typeof e) return g(e) && "max" !== e && "=" !== e.charAt(1) ? {
									x: e,
									y: e
								} : {
									y: e
								};
								if (e.nodeType) return {
									y: e,
									x: e
								};
								var n, l = {};
								for (n in e) l[n] = "onAutoKill" !== n && v(e[n]) ? e[n](t, o, r) : e[n];
								return l
							}(t, i, e, s), c.vars = t, c.autoKill = !!t.autoKill, c.getX = m(e, "x"), c.getY = m(e, "y"), c.x = c.xPrev = c.getX(), c.y = c.yPrev = c.getY(), u || (u = r.core.globals()
								.ScrollTrigger), "smooth" === r.getProperty(e, "scrollBehavior") && r.set(e, {
								scrollBehavior: "auto"
							}), a && "none" !== a && (c.snap = 1, c.snapInline = e.style.scrollSnapType, e.style.scrollSnapType = "none"), null != t.x ? (c.add(c, "x", c.x, T(t.x, e, "x", c.x, t.offsetX || 0), i, s), c._props.push("scrollTo_x")) : c.skipX = 1, null != t.y ? (c.add(c, "y", c.y, T(t.y, e, "y", c.y, t.offsetY || 0), i, s), c._props.push("scrollTo_y")) : c.skipY = 1
						},
						render: function(e, t) {
							for (var o, r, n, i, s, c = t._pt, p = t.target, f = t.tween, d = t.autoKill, y = t.xPrev, g = t.yPrev, v = t.isWin, m = t.snap, x = t.snapInline; c;) c.r(e, c.d), c = c._next;
							o = v || !t.skipX ? t.getX() : y, n = (r = v || !t.skipY ? t.getY() : g) - g, i = o - y, s = a.autoKillThreshold, t.x < 0 && (t.x = 0), t.y < 0 && (t.y = 0), d && (!t.skipX && (i > s || i < -s) && o < h(p, "x") && (t.skipX = 1), !t.skipY && (n > s || n < -s) && r < h(p, "y") && (t.skipY = 1), t.skipX && t.skipY && (f.kill(), t.vars.onAutoKill && t.vars.onAutoKill.apply(f, t.vars.onAutoKillParams || []))), v ? l.scrollTo(t.skipX ? o : t.x, t.skipY ? r : t.y) : (t.skipY || (p.scrollTop = t.y), t.skipX || (p.scrollLeft = t.x)), !m || 1 !== e && 0 !== e || (r = p.scrollTop, o = p.scrollLeft, x ? p.style.scrollSnapType = x : p.style.removeProperty("scroll-snap-type"), p.scrollTop = r + 1, p.scrollLeft = o + 1, p.scrollTop = r, p.scrollLeft = o), t.xPrev = t.x, t.yPrev = t.y, u && u.update()
						},
						kill: function(e) {
							var t = "scrollTo" === e,
								o = this._props.indexOf(e);
							return (t || "scrollTo_x" === e) && (this.skipX = 1), (t || "scrollTo_y" === e) && (this.skipY = 1), o > -1 && this._props.splice(o, 1), !this._props.length
						}
					};
				k.max = h, k.getOffset = x, k.buildGetter = m, y() && r.registerPlugin(k);
				var w = document.querySelectorAll(".phone-app-scroll__slide");
				document.querySelectorAll(".phone-app-scroll__dot");
				p.default.registerPlugin(f.ScrollTrigger, k);
				var _, S, O, P, L = document.querySelector(".phone__scroll-container"),
					X = L.scrollHeight - L.offsetHeight;
				document.querySelector(".second-scroll-block .phone-image")
					.addEventListener("load", (function() {
						X = L.scrollHeight - L.offsetHeight
					})), window.addEventListener("resize", (_ = function() {
						X = L.scrollHeight - L.offsetHeight
					}, S = 200, function() {
						var e = this,
							t = arguments,
							o = O && !P;
						clearTimeout(P), P = setTimeout((function() {
							P = null, O || _.apply(e, t)
						}), S), o && _.apply(e, t)
					}));
				var B = -1,
					E = 0;
				var Y = function(e, t) {
					var o;
					return function() {
						var r = arguments;
						o || (e.apply(this, r), o = !0, setTimeout((function() {
							return o = !1
						}), t))
					}
				}((function(e) {
					! function(e) {
						var t = null == R ? void 0 : R.clientHeight,
							o = null == I ? void 0 : I.clientHeight,
							r = e * (t - o);
						p.default.to(I, {
							y: "".concat(r, "px")
						})
					}(e), L.scrollTop = e * X
				}), 10);

				function A(e, t) {
					var o = -1;
					return window.innerWidth <= 768 ? e <= t && (o = 1) : e <= t && (o = 0), e > t && e <= .35 ? o = 1 : e > .36 && e <= .57 ? o = 2 :e > .58 && e <= .77 ? o = 3:e > .78 && e <= .88 ? o = 4: e > .89 && (o = 5), o
				}
				f.ScrollTrigger.matchMedia({
					"(min-width: 680px)": function() {
						f.ScrollTrigger.create({
							trigger: ".phone-app-scroll",
							pin: !0,
							start: "top top",
							end: "+=2000",
							scrub: !0,
							fastScrollEnd: !0,
							onUpdate: function(e) {
								E = e.progress, Y(e.progress);
								var t = A(E, .1);
								B !== t && (B = t, w.forEach((function(e, o) {
									p.default.to(e, {
										opacity: o === t ? 1 : 0,
										duration: .3,
										ease: "power2.out"
									})
								})), p.default.to(".phone-image", {
									opacity: -1 === t ? 1 : 0,
									duration: .3,
									ease: "power2.out"
								}))
							}
						})
					},
					"(max-width: 680px)": function() {
						f.ScrollTrigger.create({
							trigger: ".phone-app-scroll",
							pin: !1,
							scrub: !0
						})
					}
				});
				var H = ".phone__scroll-container",
					K = [0, .35, .66, 1],
					j = 0,
					q = document.getElementById("prevButton"),
					M = document.getElementById("nextButton");

				function C(e) {
					var t;
					p.default.to(".phone-image", {
						opacity: 1,
						duration: .3,
						ease: "power2.out"
					}), setTimeout((function() {
						p.default.to(".phone-image", {
							opacity: 0,
							duration: .3,
							ease: "power2.out"
						})
					}), 800), "next" === e && j < K.length - 1 ? j++ : "prev" === e && j > 0 && j--;
					var o = document.querySelector(H)
						.offsetTop,
						r = o + (o + (null === (t = document.querySelector(".second-scroll-block .phone-image")) || void 0 === t ? void 0 : t.clientHeight) - o) * K[j];
					0 === j ? q.classList.add("inactive") : j === K.length - 1 ? M.classList.add("inactive") : (q.classList.remove("inactive"), M.classList.remove("inactive")), p.default.to(H, {
						scrollTo: {
							y: r,
							autoKill: !1
						},
						duration: .8
					});
					var n = A(K[j], 0);
					B !== n && (B = n, w.forEach((function(e, t) {
						p.default.to(e, {
							opacity: t === n ? 1 : 0,
							duration: .3,
							ease: "power2.out"
						})
					})))
				}
				document.getElementById("nextButton")
					.addEventListener("click", (function() {
						return C("next")
					})), document.getElementById("prevButton")
					.addEventListener("click", (function() {
						return C("prev")
					}));
				var I = document.querySelector(".phone-app-scroll .scroll-bar-progress-dot"),
					R = document.querySelector(".phone-app-scroll .scroll-bar")
			}
		},
		o = {};

	function r(e) {
		var n = o[e];
		if (void 0 !== n) return n.exports;
		var l = o[e] = {
			exports: {}
		};
		return t[e](l, l.exports, r), l.exports
	}
	r.m = t, e = [], r.O = (t, o, n, l) => {
		if (!o) {
			var i = 1 / 0;
			for (u = 0; u < e.length; u++) {
				for (var [o, n, l] = e[u], s = !0, c = 0; c < o.length; c++)(!1 & l || i >= l) && Object.keys(r.O)
					.every((e => r.O[e](o[c]))) ? o.splice(c--, 1) : (s = !1, l < i && (i = l));
				if (s) {
					e.splice(u--, 1);
					var a = n();
					void 0 !== a && (t = a)
				}
			}
			return t
		}
		l = l || 0;
		for (var u = e.length; u > 0 && e[u - 1][2] > l; u--) e[u] = e[u - 1];
		e[u] = [o, n, l]
	}, r.d = (e, t) => {
		for (var o in t) r.o(t, o) && !r.o(e, o) && Object.defineProperty(e, o, {
			enumerable: !0,
			get: t[o]
		})
	}, r.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t), r.r = e => {
		"undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
			value: "Module"
		}), Object.defineProperty(e, "__esModule", {
			value: !0
		})
	}, (() => {
		var e = {
			1041: 0
		};
		r.O.j = t => 0 === e[t];
		var t = (t, o) => {
				var n, l, [i, s, c] = o,
					a = 0;
				if (i.some((t => 0 !== e[t]))) {
					for (n in s) r.o(s, n) && (r.m[n] = s[n]);
					if (c) var u = c(r)
				}
				for (t && t(o); a < i.length; a++) l = i[a], r.o(e, l) && e[l] && e[l][0](), e[l] = 0;
				return r.O(u)
			},
			o = self.webpackChunkwebpack_shopify_FORM = self.webpackChunkwebpack_shopify_FORM || [];
		o.forEach(t.bind(null, 0)), o.push = t.bind(null, o.push.bind(o))
	})();
	var n = r.O(void 0, [5361], (() => r(2278)));
	n = r.O(n)
})();